import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { getKeywordToolPage } from '@/components/astro/new-design-25/SEO/keyword-tool-data';
import { KeywordToolSeoPage } from '@/components/astro/new-design-25/SEO/keyword-tool-pages';
import { pdfToAudioSearch } from '@/lib/pdf-to-audio-search';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

const page = getKeywordToolPage('academic-paper-reader');
if (!page) throw new Error('Missing keyword SEO page: academic-paper-reader');

export const Route = createFileRoute('/_marketing/_seo/academic-paper-reader')({
  validateSearch: pdfToAudioSearch,
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title: page.metaTitle,
        description: page.metaDescription,
      }),
    ],
    links: [
      {
        rel: 'canonical',
        href: normalizeCanonicalUrl('/academic-paper-reader'),
      },
    ],
  }),
  component: () => <KeywordToolSeoPage page={page} />,
});
